import React, { FC } from 'react'
import { useField, FormikProps } from 'formik'

import { ReactComponent as TooltipInfo } from 'assets/images/mini_tooltip.svg'
import { CloseCircleFilled } from '@ant-design/icons'

import { Checkbox, Tooltip } from '@pepper/ui'
import { dataLayerEnableMultiCategoryEvent } from '@pepper/utils/src/function/dataLayerEvents'

import styles from './_.module.css'

interface Props {
  name: string
  verticalName: string
  verticalID: number
  rootVerticalName: string
  label?: string
  required?: boolean
  body?: IProjectBody[]
  actions: FormikProps<any>
  defaultStaticValue: string | number
  renderAsCheckbox?: boolean
  miniTooltip?: string
  onClick?: (val: boolean) => void
}

const MultiCategoryToggle: FC<Props> = ({
  name,
  label,
  required,
  miniTooltip,
  onClick,
  verticalName,
  rootVerticalName,
}) => {
  const [field, meta, helpers] = useField(name)

  const updateValue = (val: boolean) => {
    onClick && onClick(val)
    const verticalIndex = field?.value?.indexOf(verticalName)
    const isExists = verticalIndex > -1
    const tempVal = field?.value ?? []
    if (val) {
      if (!isExists) {
        tempVal.push(verticalName)
        dataLayerEnableMultiCategoryEvent({
          rootVertical: rootVerticalName,
          optedVertical: verticalName,
        })
      }
    } else {
      tempVal.splice(verticalIndex, 1)
    }
    helpers.setValue(tempVal)
  }
  const checkIsSelected = () => {
    return field?.value?.indexOf(verticalName) > -1
  }
  return (
    <>
      <div className={styles.switchWrap}>
        <div className={styles.headerWrap}>
          <>
            <div className={styles.checkboxWrap}>
              <Checkbox
                defaultChecked={checkIsSelected()}
                className={styles.switchTag}
                onChange={event => updateValue(event?.target?.checked)}
              />
            </div>
            <span className={styles.labelText}>{label}</span>
            {required && <span className={styles.requiredText}>*</span>}
            {miniTooltip && (
              <Tooltip
                placement="top"
                title={() => (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: miniTooltip,
                    }}
                  />
                )}
              >
                <TooltipInfo className={styles.tooltipPos} />
              </Tooltip>
            )}
          </>
        </div>
        {meta.touched && meta.error ? (
          <div className={styles.error}>
            <CloseCircleFilled className={styles.errorIcon} /> {meta.error}
          </div>
        ) : null}
      </div>
    </>
  )
}

export default MultiCategoryToggle
